import * as Icons from '@vw-marketing/us-components';
import React from 'react';

export const iconMap: Record<string, React.ComponentType<any>> = {
  Acceleration: Icons.Acceleration,
  Accessories: Icons.Accessories,
  AccessoryParts: Icons.AccessoryParts,
  Add: Icons.Add,
  AddCircle: Icons.AddCircle,
  AddCircleFilled: Icons.AddCircleFilled,
  Ai: Icons.Ai,
  AiSearchError: Icons.AiSearchError,
  AirConditioning: Icons.AirConditioning,
  Alert: Icons.Alert,
  Archive: Icons.Archive,
  ArrowDown: Icons.ArrowDown,
  ArrowLeft: Icons.ArrowLeft,
  ArrowRight: Icons.ArrowRight,
  ArrowUp: Icons.ArrowUp,
  AwardWinnerPremium: Icons.AwardWinnerPremium,
  Back: Icons.Back,
  Battery: Icons.Battery,
  BatteryCalculator: Icons.BatteryCalculator,
  BatteryCharging: Icons.BatteryCharging,
  BatteryCost: Icons.BatteryCost,
  BatteryDestination: Icons.BatteryDestination,
  Bin: Icons.Bin,
  Bluetooth: Icons.Bluetooth,
  Bookmark: Icons.Bookmark,
  BookmarkFilled: Icons.BookmarkFilled,
  Brochure: Icons.Brochure,
  Business: Icons.Business,
  BusinessCustomersCommercial: Icons.BusinessCustomersCommercial,
  BusinessCustomersPrivate: Icons.BusinessCustomersPrivate,
  Cabrio: Icons.Cabrio,
  Calc: Icons.Calc,
  Calendar: Icons.Calendar,
  CaliforniaService: Icons.CaliforniaService,
  CaliforniaSpecialist: Icons.CaliforniaSpecialist,
  CameraScan: Icons.CameraScan,
  CarDocuments: Icons.CarDocuments,
  CarInfo: Icons.CarInfo,
  CarInsurance: Icons.CarInsurance,
  CarLeasing: Icons.CarLeasing,
  CarPickupService: Icons.CarPickupService,
  CarSettings: Icons.CarSettings,
  CarWheel: Icons.CarWheel,
  Carwash: Icons.Carwash,
  CertifiedRepair: Icons.CertifiedRepair,
  CertifiedRetailer: Icons.CertifiedRetailer,
  Charging: Icons.Charging,
  ChargingStation: Icons.ChargingStation,
  Chat: Icons.Chat,
  Checkbox: Icons.Checkbox,
  CheckboxSelected: Icons.CheckboxSelected,
  Checkmark: Icons.Checkmark,
  CheckmarkCircle: Icons.CheckmarkCircle,
  CheckmarkCircleFilled: Icons.CheckmarkCircleFilled,
  ChevronDown: Icons.ChevronDown,
  ChevronLeft: Icons.ChevronLeft,
  ChevronRight: Icons.ChevronRight,
  ChevronUp: Icons.ChevronUp,
  City: Icons.City,
  Clock: Icons.Clock,
  Close: Icons.Close,
  CloseCircle: Icons.CloseCircle,
  Compact: Icons.Compact,
  Compare: Icons.Compare,
  ConfiguratorCommercial: Icons.ConfiguratorCommercial,
  ConfiguratorPrivate: Icons.ConfiguratorPrivate,
  Consumption: Icons.Consumption,
  Contact: Icons.Contact,
  ContactDealer: Icons.ContactDealer,
  Corporate: Icons.Corporate,
  CountryRoad: Icons.CountryRoad,
  Coupe: Icons.Coupe,
  CustomerCenter: Icons.CustomerCenter,
  DataExpired: Icons.DataExpired,
  DataFilled: Icons.DataFilled,
  DataInput: Icons.DataInput,
  DataSearch: Icons.DataSearch,
  DataTimeExtension: Icons.DataTimeExtension,
  Dealer: Icons.Dealer,
  DealerInfo: Icons.DealerInfo,
  DefogDefrost: Icons.DefogDefrost,
  Delivery: Icons.Delivery,
  Diesel: Icons.Diesel,
  Direction: Icons.Direction,
  Discount: Icons.Discount,
  Door: Icons.Door,
  Download: Icons.Download,
  DownloadTranscript: Icons.DownloadTranscript,
  DriverAssistance: Icons.DriverAssistance,
  Eco: Icons.Eco,
  EconomyService: Icons.EconomyService,
  Edit: Icons.Edit,
  Efficiency: Icons.Efficiency,
  Electric: Icons.Electric,
  ElectricCars: Icons.ElectricCars,
  ElectricCarsService: Icons.ElectricCarsService,
  ElectricEngine: Icons.ElectricEngine,
  Electricity: Icons.Electricity,
  Emission: Icons.Emission,
  Energy: Icons.Energy,
  Engine: Icons.Engine,
  EnterFullscreen: Icons.EnterFullscreen,
  Entertainment: Icons.Entertainment,
  ExitFullscreen: Icons.ExitFullscreen,
  ExpressService: Icons.ExpressService,
  Exterior: Icons.Exterior,
  ExternalLink: Icons.ExternalLink,
  Facebook: Icons.Facebook,
  Faq: Icons.Faq,
  FastForward: Icons.FastForward,
  Fax: Icons.Fax,
  Filter: Icons.Filter,
  FilterError: Icons.FilterError,
  Finance: Icons.Finance,
  FindCar: Icons.FindCar,
  FindDealer: Icons.FindDealer,
  FleetServiceCommercial: Icons.FleetServiceCommercial,
  FleetServicePrivate: Icons.FleetServicePrivate,
  Gallery: Icons.Gallery,
  Garage: Icons.Garage,
  Gas: Icons.Gas,
  GasCarsService: Icons.GasCarsService,
  Gte: Icons.Gte,
  Heart: Icons.Heart,
  HeartFilled: Icons.HeartFilled,
  HighwayRoad: Icons.HighwayRoad,
  Home: Icons.Home,
  Hybrid: Icons.Hybrid,
  Info: Icons.Info,
  InfoFilled: Icons.InfoFilled,
  InfoWithoutCircle: Icons.InfoWithoutCircle,
  InputHide: Icons.InputHide,
  InputShow: Icons.InputShow,
  Instagram: Icons.Instagram,
  Interior: Icons.Interior,
  Interior360: Icons.Interior360,
  Internet: Icons.Internet,
  JobPortal: Icons.JobPortal,
  LinkExternal: Icons.LinkExternal,
  Linkedin: Icons.Linkedin,
  List: Icons.List,
  Load: Icons.Load,
  LoadingTimeAc: Icons.LoadingTimeAc,
  LoadingTimeDc: Icons.LoadingTimeDc,
  LoadingVolume: Icons.LoadingVolume,
  LocalBusiness: Icons.LocalBusiness,
  Locate: Icons.Locate,
  Lock: Icons.Lock,
  LockOpen: Icons.LockOpen,
  Login: Icons.Login,
  Logout: Icons.Logout,
  Magnifier: Icons.Magnifier,
  MagnifierMinus: Icons.MagnifierMinus,
  MagnifierPlus: Icons.MagnifierPlus,
  Mail: Icons.Mail,
  Manual: Icons.Manual,
  Map: Icons.Map,
  Media: Icons.Media,
  Megaphone: Icons.Megaphone,
  Menu: Icons.Menu,
  Mobile: Icons.Mobile,
  Mot: Icons.Mot,
  Motability: Icons.Motability,
  Multivan: Icons.Multivan,
  Navigate: Icons.Navigate,
  NewCarCommercial: Icons.NewCarCommercial,
  NewCarPrivate: Icons.NewCarPrivate,
  NewCarUtilityVehicle: Icons.NewCarUtilityVehicle,
  Newsletter: Icons.Newsletter,
  NightService: Icons.NightService,
  Notification: Icons.Notification,
  NotificationFilled: Icons.NotificationFilled,
  OfferBadgeBackground: Icons.OfferBadgeBackground,
  OfferBadgeIcon: Icons.OfferBadgeIcon,
  Offers: Icons.Offers,
  OilLevel: Icons.OilLevel,
  OilLevelWarning: Icons.OilLevelWarning,
  OilTemperature: Icons.OilTemperature,
  OnCallService: Icons.OnCallService,
  OpenInLayer: Icons.OpenInLayer,
  OpenSaturday: Icons.OpenSaturday,
  PaintShop: Icons.PaintShop,
  Pause: Icons.Pause,
  Payload: Icons.Payload,
  PdfFile: Icons.PdfFile,
  Performance: Icons.Performance,
  Petrol: Icons.Petrol,
  Phone: Icons.Phone,
  Pin: Icons.Pin,
  PinSelectable: Icons.PinSelectable,
  PinSelected: Icons.PinSelected,
  Pinterest: Icons.Pinterest,
  Play: Icons.Play,
  PlusService: Icons.PlusService,
  PopularCarComercial: Icons.PopularCarComercial,
  PopularCarPrivate: Icons.PopularCarPrivate,
  Powertrain: Icons.Powertrain,
  PriceTypeSwitch: Icons.PriceTypeSwitch,
  Printer: Icons.Printer,
  Profile: Icons.Profile,
  ProfileCircle: Icons.ProfileCircle,
  ProofOfOwnership: Icons.ProofOfOwnership,
  QualifiedWorkshop: Icons.QualifiedWorkshop,
  Radio: Icons.Radio,
  RadioButton: Icons.RadioButton,
  RadioButtonSelected: Icons.RadioButtonSelected,
  Random: Icons.Random,
  Range: Icons.Range,
  Reload: Icons.Reload,
  Remove: Icons.Remove,
  RemoveCircle: Icons.RemoveCircle,
  RemoveCircleFilled: Icons.RemoveCircleFilled,
  Repeat: Icons.Repeat,
  RequestQuote: Icons.RequestQuote,
  Rewind: Icons.Rewind,
  RoadsideAssistance: Icons.RoadsideAssistance,
  Route: Icons.Route,
  Rss: Icons.Rss,
  Safety: Icons.Safety,
  Save: Icons.Save,
  Seat: Icons.Seat,
  SeatAir: Icons.SeatAir,
  Sedan: Icons.Sedan,
  Service: Icons.Service,
  ServiceBell: Icons.ServiceBell,
  Settings: Icons.Settings,
  ShareAndroid: Icons.ShareAndroid,
  ShareIOS: Icons.ShareIOS,
  ShoppingCart: Icons.ShoppingCart,
  Shuffle: Icons.Shuffle,
  Size: Icons.Size,
  SkipBackward: Icons.SkipBackward,
  SkipForward: Icons.SkipForward,
  Sound: Icons.Sound,
  StandardEquipment: Icons.StandardEquipment,
  StarFilled: Icons.StarFilled,
  StarOutline: Icons.StarOutline,
  Statistics: Icons.Statistics,
  SteeringWheel: Icons.SteeringWheel,
  StockLocatorCommercial: Icons.StockLocatorCommercial,
  StockLocatorPrivate: Icons.StockLocatorPrivate,
  Stop: Icons.Stop,
  Suv: Icons.Suv,
  Sync: Icons.Sync,
  TaxiDealer: Icons.TaxiDealer,
  TechnicalSpecification: Icons.TechnicalSpecification,
  TestDrive: Icons.TestDrive,
  ThreeDMode: Icons.ThreeDMode,
  Tiktok: Icons.Tiktok,
  Timer: Icons.Timer,
  TouaregService: Icons.TouaregService,
  Touring: Icons.Touring,
  TransmissionAuto: Icons.TransmissionAuto,
  TransmissionManual: Icons.TransmissionManual,
  Twitter: Icons.Twitter,
  Upload: Icons.Upload,
  UsedCarCommercial: Icons.UsedCarCommercial,
  UsedCarPrivate: Icons.UsedCarPrivate,
  VWCode: Icons.VWCode,
  VehicleAmarok: Icons.VehicleAmarok,
  VehicleCaddy: Icons.VehicleCaddy,
  VehicleConversion: Icons.VehicleConversion,
  VehicleCrafter: Icons.VehicleCrafter,
  VehicleCrafterDrop: Icons.VehicleCrafterDrop,
  VehicleHeight: Icons.VehicleHeight,
  VehicleIdBuzz: Icons.VehicleIdBuzz,
  VehicleMultivan: Icons.VehicleMultivan,
  VehicleTransporter: Icons.VehicleTransporter,
  VideoChat: Icons.VideoChat,
  View360: Icons.View360,
  VirtualReality: Icons.VirtualReality,
  VolumeMaximum: Icons.VolumeMaximum,
  VolumeMedium: Icons.VolumeMedium,
  VolumeMute: Icons.VolumeMute,
  Wallbox: Icons.Wallbox,
  WeCharge: Icons.WeCharge,
  WeUpgrade: Icons.WeUpgrade,
  Wheelbase: Icons.Wheelbase,
  WindscreenWash: Icons.WindscreenWash,
  Wlan: Icons.Wlan,
  Youtube: Icons.Youtube,
  // Default fallback
  default: Icons.Acceleration,
};
